module.exports = __webpack_public_path__ + "img/camp07_actived.80be5334.png";